import styled from 'styled-components'

export default styled.div`
`



// WEBPACK FOOTER //
// ./src/components/DashboardWidget/SettingsContainer.js